import Icon from '../atomic/Icon'
import Trans from '../atomic/Trans'
import dynamic from 'next/dynamic'
import { useState } from 'react'

const Login = dynamic(() => import('../atomic/Login'))

const Vantaggi = () => {
  const [login, setLogin] = useState(false)

  const handleLogin = login => setLogin(login)

  return (
    <section className="registrazione-page__vantaggi u-bg-beige">
      <div className="container">
        <div className="registrazione-page__vantaggi-cards vantaggi">
          <div className="vantaggi__item">
            <Icon id="time" />
            <p className="vantaggi__title">
              <Trans chiave="vantaggi-item-title-1" />
            </p>
            <p className="vantaggi__description">
              <Trans chiave="vantaggi-item-description-1" />
            </p>
          </div>
          <div className="vantaggi__item">
            <Icon id="copy" />
            <p className="vantaggi__title">
              <Trans chiave="vantaggi-item-title-2" />
            </p>
            <p className="vantaggi__description">
              <Trans chiave="vantaggi-item-description-2" />
            </p>
          </div>
          <div className="vantaggi__item">
            <Icon id="community" />
            <p className="vantaggi__title">
              <Trans chiave="vantaggi-item-title-3" />
            </p>
            <p className="vantaggi__description">
              <Trans chiave="vantaggi-item-description-3" />
            </p>
          </div>
        </div>
        {/*
        <div className="registrazione-page__loghi">
          <p className="registrazione-page__loghi__title">
            <span>
              <Trans chiave="Più contenuti," />
            </span>
            <span>
              <Trans chiave="un solo punto di accesso" />
            </span>
          </p>
          <p className="registrazione-page__loghi__description">
            <Trans chiave="Più contenuti disclaimer" />
          </p>
          <div className="registrazione-page__loghi__list loghi">
            <div className="loghi__item">
              <img src="https://via.placeholder.com/137x44" className="loghi__image" />
            </div>
            <div className="loghi__item">
              <img src="https://via.placeholder.com/137x44" className="loghi__image" />
            </div>
            <div className="loghi__item">
              <img src="https://via.placeholder.com/137x44" className="loghi__image" />
            </div>
            <div className="loghi__item">
              <img src="https://via.placeholder.com/137x44" className="loghi__image" />
            </div>
            <div className="loghi__item">
              <img src="https://via.placeholder.com/137x44" className="loghi__image" />
            </div>
            <div className="loghi__item">
              <img src="https://via.placeholder.com/137x44" className="loghi__image" />
            </div>
            <div className="loghi__item">
              <img src="https://via.placeholder.com/137x44" className="loghi__image" />
            </div>
            <div className="loghi__item">
              <img src="https://via.placeholder.com/137x44" className="loghi__image" />
            </div>
          </div>
          <div className="registrazione-page__cta-box">
            <a
              className="registrazione-page__cta button button--primary"
              onClick={() => handleLogin(true)}
            >
              <Trans chiave="Accedi" />
            </a>
          </div>
        </div>
        */}
      </div>
      {login && <Login isOpen={login} setLogin={handleLogin} />}
    </section>
  )
}

export default Vantaggi
